export default Object.freeze({

  YEAR: " ano",
  MONTH: " mês",
  MONTHS: " meses",
  DAY: " dia",
  HOUR: " hora",
  MINUTE: " minuto",
  SELECT_REPORT_TYPE: "Por favor selecione ao menos um canal para gerar o relatório.",

  /// ---------------------------- Menu Bar ---------------------------- 
  CHANNEL_1: "Canal 1",
  CHANNEL_2: "Canal 2",
  CHANNEL_3: "Canal 3",
  CHANNEL_4: "Canal 4",

  LIVE_LIST: "Live List",
  LIVE_LIST_MATRIX: "Matriz",
  OSCILLOSCOPE: "Osciloscópio",
  BAR_GRAPH: "Gráfico de barras",
  LOG: "Log",
  REPORT: "Relatório",
  CONFIG: "Configurações",

  // ---------------------------- Live List ----------------------------
  GOOD_STRING: "Bom",
  ATTENTION_STRING: "Atenção",
  BAD_STRING: "Ruim",
  FAULT_STRING: "Sem sinal",
  UNKNOWN_STRING: "Desconhecido",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por endereço ou sinal",

  REMOVE_POSITIONING: "Excluir dispositivo em falha",
  REMOVE_DEVICE_MODAL_CONTENT_1: "Tem certeza que deseja excluir o dispositivo?",
  REMOVE_DEVICE_SUCCESS: "O dispositivo será removido na próxima varredura.",
  REMOVE_DEVICE_FAILURE: "Ocorreu um erro ao remover o dispositivo: ",
  LIVE_LIST_DEVICE_FAULT_POPUP_TEXT_2: "Ao clicar na célula é possível excluir o dispositivo, caso queira.",
  ADDRESS: "Endereço",
  AMPLITUDE: "Amplitude",
  UNBALANCE: "Desbalanceamento",
  MIN_AMPLITUDE: "Amplitude mínima",
  MAX_AMPLITUDE: "Amplitude máxima",
  DEVIATION: "Desvio",
  NOISE: "Ruído",
  I_FAULTS: "Falhas",
  STATUS: "Sinal",
  SIGNAL: "Sinal",
  JITTER: "Jitter",
  FAULT_PERCENT: "% de falha",
  COMMUNICATION: "Comunicação",
  FAULT: "Falha",
  DATA_EXCHANGE_1: "Troca de",
  DATA_EXCHANGE_2: "dados",
  DATA_EXCHANGE: "Troca de dados",
  DATA_EXCHANGE_LINE1: "Troca\n",
  DATA_EXCHANGE_LINE2: "de\n",
  DATA_EXCHANGE_LINE3: "dados",

  PORCENTAGEM: "%",
  MILLIVOLT: "mV",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  A: "A",
  B: "B",
  CHANNEL_A_PROBLEM: "Indicativo de problema no canal A",
  CHANNEL_B_PROBLEM: "Indicativo de problema no canal B",
  MASTERS: "Manager",
  SLAVES: "Devices",
  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",
  CURRENT_CHANNEL: "Canal atual",
  CHANNEL_TAG_STR: "Tag do canal",

  NETWORK_DATA: "Dados da rede",

  MODAL_TITLE: "Formas de onda caracteristicas",

  TURNED_ON: "Ligada",
  TURNED_OFF: "Desligada",

  ANALYSIS_ERROR: "Ocorreu um erro ao alterar o estado da análise",

  ANALYSIS: "Análise",
  ANALYZER: "Analisador",

  DETECTED_PROBLEMS: "Problemas detectados:",
  INIT_PICO_NOT_FOUND: "O TS Scope H1 encontrou um erro interno que o impediu de funcionar corretamente. Por favor, reinicie o TS Scope H1. Caso o problema persista entre em contato com a Toledo & Souza para obter suporte.",
  INVERTED_POLARITY: "Existem dispositivos na rede com polaridade invertida.",
  MONGO_OFF: "O TS Scope H1 detectou um erro em sua base de dados interna. Por favor, reinicie o TS Scope H1. Caso o problema persista entre em contato com a Toledo & Souza para obter suporte.",
  PICO_NOT_FOUND: "O TS Scope H1 encontrou um erro interno que o impediu de funcionar corretamente. Por favor, reinicie o TS Scope H1. Caso o problema persista entre em contato com a Toledo & Souza para obter suporte.",
  MONGO_REPAIR_SUCCESS: "Erro reparado com sucesso! Por favor feche o programa e abra novamento para que as alterações tenham efeito.",
  MONGO_REPAIR_ERROR: "Não foi possível solucionar o problema. Por favor entre em contato para receber suporte.",
  SCAN_FAIL_FOUND: "O TS Scope H1 perdeu a conexão com a rede com meio físico H1, certifique-se de que ele está conectado corretamente à rede. Após realizar a conexão, por favor reinicie o TS Scope H1.",

  REPAIR: "Reparar",
  LOADING_ANALYZER: "Iniciando analisador, por favor aguarde.",

  A_DEVICES: "Dispositivos A",
  B_DEVICES: "Dispositivos B",

  AMPLITUDE_POPUP_STR1: "Mostra a amplitude atual, mínima e máxima do sinal de cada um dos dispositivos da rede.",
  AMPLITUDE_POPUP_STR2: "O valor mínimo é de 3Vpp e o máximo de 8Vpp.",
  SIGNAL_POPUP_STR: "Indicativo de que a amplitude está fora da norma.",
  I_FAULTS_POPUP_STR: "Device com problema na troca de dados.",
  NOISE_POPUP_STR: "O Ruído</b> é calculado durante o tempo de <b><i>idle</i></b> de cada um dos Devices na rede e não deve exceder <b>100 mV</b>.Estes valores são de ordem prática.",
  DEV_POPUP_STR1: "Indica o valor de desvio do sinal em relação ao oscilador de frequência, ou seja, a relação de tempo entre onde o sinal deveria cruzar o zero e efetivamente onde está cruzando.",
  DEV_POPUP_STR2: "Pode indicar acoplamento capacitivo ao barramento ou ainda problema no hardware.",
  DEV_POPUP_STR3: "Os limites são -0,8μs a + 1,6μs.",

  DATA_EXCHANGE_POPUP_STR_1: "Indica que o devices está em troca de dados com o Maanager.",
  DATA_EXCHANGE_POPUP_STR_2: "Indica que o devices parou de trocar dados com o manager.",

  FAULT_POPUP_STR_1: "Não ocorrência de problemas nas trocas de dados.",
  FAULT_POPUP_STR_2: "Indica que em algum momento durante a análise houve a ocorrência de retentativa.",
  FAULT_POPUP_STR_3: "Indica que em algum momento durante a análise o devices deixou de trocar dados com o manager.",
  FAULT_POPUP_STR_4: "O TS Scope H1 realiza a leitura dos dados em blocos, e não em streaming. Por conta disso, caso ocorram retentativas fora da janela de leitura, elas não serão detectadas pelo analisador.",
  PS: "OBS:",

  ANALYSIS_INIT_ERROR: "Ocorreu um erro ao iniciar a análise, por favor tente iniciar novamente.",
  LOADING_HOMEPAGE_2: "Este processo pode levar alguns minutos.",
  CANCEL: "Cancelar",

  NO_ACTIVE_NETWORK: "O TS Scope H1 não encontrou uma rede ativa, certifique-se de que ele está conectado corretamente a uma rede com meio físico H1. Após realizar a conexão, por favor reinicie o TS Scope H1.",
  INVALID_SERIAL: "O número de série não corresponde a este TS Scope H1. Por favor reinstale o programa com um número de série válido.",

  CLEANING_BUFFER: "Limpando buffer...",
  SEPARATING_WAVES: "Analisando dados...",
  VERIFYING_NETWORK_TYPE: "Verificando rede...",
  FINDING_SLAVES: "Encontrando devices...",

  // ---------------------------- Oscilloscope ----------------------------
  GRAPH: "Gráfico",
  A_AND_B: "A e B",
  B_A: "B - A",
  WAVE_FORM: "Forma de onda",
  AMPLITUDE_A: "Amplitude A",
  AMPLITUDE_B: "Amplitude B",
  ADDRESS_DP: "Endereço: ",
  CHANNEL_DP: "Canal: ",
  WAVE_A: "Sinal A",
  WAVE_B: "Sinal B",
  WAVE_H1: "Amplitude",

  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",
  SECOND: "s",

  TIME_NS: "Tempo (ns)",
  TIME_US: "Tempo (μs)",
  TIME_MS: "Tempo (ms)",
  TIME_S: "Tempo (s)",

  AMPLITUDE_PLACEHOLDER: "0,0 mV",
  TIME_INTERVAL_PLACEHOLDER: "0,0 ",
  CURSORS: "Cursores",
  CONTROLS: "Controles ",
  TIME_INTERVAL: " tempo",
  CONTROLS_POPUP_TEXT: "Após apertar PLAY, a forma de onda é atualizada a cada 2 segundos.",
  CONTROLS_POPUP_TEXT_2: "Para liberar os controles é preciso selecionar a visualização manual e escolher um dispositivo.",

  VISUALIZATION: "Visualização",
  AUTOMATIC: "Automática",
  MANUAL: "Manual",

  KBPS: "Kbps",

  // ---------------------------- Bar Graph ----------------------------
  ORDER_BY: "Classificar por",
  AMPLITUDE_ASC: "Amplitude crescente",
  AMPLITUDE_DESC: "Amplitude decrescente",
  ADDRESS_ASC: "Endereço crescente",
  VOLTAGE_V: "Tensão (V)",
  VOLTAGE_MV: "Tensão (mV)",
  UNBALANCE_PORCENT: "Taxa de Desbalanceamento (%)",
  VOLTAGE_V_PEAK_TO_PEAK: "Tensão (V)",
  ORDER: "Ordenação",
  REFRESH_DATA: "Atualizar dados",
  LOADING: "Carregando",
  BAR_GRAPH_TYPE_PLACEHOLDER: "Selecione um tipo de gráfico de barras",
  ACTUAL: "Atual",
  VARIATION: "Variação",
  CURRENT: "Atual",
  MICROSSECOND_TITLE: "Microsegundos (µs)",

  NOISE_H1: "Ruído: ",
  NOISE_MIN: "Ruído Mínimo",
  NOISE_MAX: "Ruído Máximo",
  NOISE_ASC: "Ruído crescente",
  NOISE_DESC: "Ruído decrescente",

  JITTER_H1: "Jitter: ",
  JITTER_MIN: "Jitter Mínimo",
  JITTER_MAX: "Jitter Máximo",
  JITTER_ASC: "Jitter crescente",
  JITTER_DESC: "Jitter decrescente",

  UNBALANCE_H1: "Desbalanceamento: ",
  UNBALANCE_ASC: "Desbalanceamento crescente",
  UNBALANCE_DESC: "Desbalanceamento decrescente",

  MINIMUM_MASC: "Mínimo",
  MINIMUM_FEM: "Mínima",
  MAXIMUM_MASC: "Máximo",
  MAXIMUM_FEM: "Máxima",

  COMPLETE: "Completo",
  DETAILED: "Detalhado",

  MODE_POPUP_TEXT_1: "O modo detalhado mostra a parte inicial da forma de onda completa que foi capturada (Como se fosse dado um zoom na parte inicial da onda).",
  MODE_POPUP_TEXT_2: "Já o modo completo mostra a forma de onda em sua totalidade.",

  // ---------------------------- Log ----------------------------
  INSERT_VALID_ADDRESS_OR_TYPE: "Favor digite um tipo de evento válido.",
  BEFORE_MONITOR_INIT_STR: "Anterior à última inicialização",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar por endereço ou tipo de evento",
  LOG_WAITING: "Carregando dados do log",
  HORARY: "Horário",
  DESCRIPTION: "Descrição",
  TYPE: "Tipo",

  H1_TERMINATION_OFF_LOG_DESCRIPTION: "O TS Expert detectou uma condição de falta de teminação.",
  H1_CAPACITIVE_EFFECT_LOG_DESCRIPTION: "O TS Expert detectou uma condição de Jitter fora de especificação.",
  H1_NOISE_LOG_DESCRIPTION: "O TS Expert detectou uma possível condição de ruído na rede.",
  H1_INVERTED_POLARITY_LOG_DESCRIPTION: "O TS Expert detectou uma possível condição de inversão de polaridades.",
  H1_HIGH_RESISTANCE_LOG_DESCRIPTION: "O TS Scope H1 detectou uma condição de sinal atenuado.",
  H1_UNBALANCE_LOG_DESCRIPTION: "O TS Scope H1 detectou uma condição de desbalanceamento.",
  EVENT_CHECKED_SUCCESS: "O evento foi limpo com sucesso.",

  // ---------------------------- Report ----------------------------
  REPORT_EXPORT_NAME: "Relatório TS Scope H1",

  HEADER_TEXT: "TS Scope H1",
  GENERATE_REPORT: "Gerar relatório",

  SELECT_CLIENT: "Clientes salvos",
  SELECT_EXECUTOR: "Empresas executoras salvas",
  CLIENT_NOT_FOUND: "Sem clientes salvos com esse nome",
  EXECUTOR_NOT_FOUND: "Sem empresas salvas com esse nome",

  GENERAL_REPORT: "Relatório geral – TS Scope H1",
  DATA_REPORT: "Relatório de dados – TS Scope H1",

  CLIENT_INFO: "Informações do cliente",
  EXECUTING_COMPANY_INFO: "Informações da empresa executora",
  CONFORMITY: "Conformidade",
  ANNOTATIONS: "Anotações",
  CONCLUSION: "Conclusão",

  DROPDOWN_PLACEHOLDER: "Escolha uma opção",
  CONFORM: "Conforme",
  CONFORM_W_RESTRICTION: "Conforme com restrições",
  NON_CONFORM: "Não conforme",

  PROJECT_NAME: "- Nome do projeto:",
  NETWORK_NAME: "- Nome da rede:",
  LOCATION: "- Localização:",
  COMPANY_NAME: "- Nome da empresa:",
  ACCOUNTABLE_NAME: "- Nome do responsável:",
  COMPANY_ADDRESS: "- Endereço:",
  COMPANY_CITY: "- Cidade:",
  COMPANY_TEL: "- Telefone:",

  EXECUTING_COMPANY_NAME: "- Nome da empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nome do responsável:",
  EXECUTING_TEL: "- Telefone:",
  EXECUTING_EMAIL: "- Email:",

  ETHERNET_INFO: "Informações ETHERNET",

  IP_DP: "- IP: ",
  MASK_DP: "- Máscara: ",
  GATEWAY_DP: "- Gateway: ",

  NETWORK_NAME_DP: "- Nome da rede: ",

  SUMMARY: "Sumário",
  CHANNEL: "Canal",
  LIVE_LIST_PAGE_TITLE: "1 - Live List",
  OSCILLOSCOPE_PAGE_TITLE: "2 - Osciloscópio",
  BAR_GRAPH_PAGE_TITLE: "3 - Gráfico de barras",
  LOG_PAGE_TITLE: "4. - Log de eventos",

  LAST_200_EVENTS: "200 últimos eventos",

  PHYSICAL_ENVIRONMENT: "- Meio Físico:",
  PHYSICAL_ENVIRONMENT_TYPE: "H1",

  ANALYZER_VERSION_STRING: "- Versão do TS Scope H1:",
  ANALYSIS_INIT: "- Horário de início da análise:",

  ANALYSIS_INFO: "Informações da análise",
  GENERATED_BY: "- Gerado por TS Scope H1",
  HARDWARE_VERSION: "- Versão de hardware:",
  SOFTWARE_VERSION: "- Versão de software:",
  DATE_TIME: "- Data e hora:",
  BAUD_RATE: "- Baud rate:",
  NUM_MASTERS: "- Manager:",
  NUM_SLAVES: "- Devices:",

  LIVE_LIST_DOTS: ".....................................................................................................................................",
  BAR_DOTS: "......................................................................................................................",
  OSC_DOTS: ".............................................................................................................................",
  LOG_DOTS: ".............................................................................................................................................",
  DISCLAIMER_DOTS: ".................................................................................................................................",

  GENERATING_REPORT_WAITING: "Gerando relatório, por favor aguarde",
  GENERATING_REPORT_SUCCESS: "Relatório gerado com sucesso. Para salvá-lo, clique em salvar relatório abaixo.",

  MASTER_H1: "Manager: ",
  SLAVE_H1: "Device: ",
  SIGNAL_H1: "Sinal: ",
  AMPLITUDE_H1: "Amplitude: ",
  AMPLITUDE_MIN_H1: "Amplitude mínima: ",
  AMPLITUDE_MAX_H1: "Amplitude máxima: ",
  DEVIATION_DP: "Desvio: ",
  I_FAULTS_DP: "Falhas: ",
  PERCENT_FAULTS_DP: "% de falhas: ",

  OVERSHOOTING_DP: "Sobressinal: ",

  END_OF_REPORT: "Fim do relatório",
  DISCLAIMER: "Aviso legal",
  DISCLAIMER_TEXT: "Os dados e valores apresentados neste relatório são meramente auxiliares para o especialista em H1, de tal sorte que qualquer indicação de correção deve ser feita pelo usuário. Por esta razão, recomenda-se acompanhamento de engenheiro especialista ou técnico responsável pela análise para atestar as informações prestadas pelo produto. Portanto a Toledo & Souza se exime de quaisquer responsabilidades, perdas ou danos, diretos ou indiretos causados pelas interpretações do software, não oferecendo nenhuma garantia em relação à integridade, qualidade ou adequação das informações prestadas, pois dependem da análise técnica de um profissional capacitado, sendo que na falta deste, o usuário assumirá o risco de que o conteúdo possa ser impreciso, incompleto ou possa não atender às suas necessidades e requisitos.",

  // ---------------------------- Manage Information ----------------------------
  SAVE: "Salvar",
  REMOVE: "Remover",

  CHOOSE_CLIENT_ID: "É necessário escolher um identificador para o cliente.",
  CLIENT_ID_ALREADY_EXISTS: "Já existe um cliente salvo com esse identificador.",
  SAVE_CLIENT_SUCCESS: "Cliente salvo com sucesso!",
  SAVE_CLIENT_ERROR: "Ocorreu um erro ao salvar as informações do cliente.",

  CHOOSE_EXECUTING_COMPANY_ID: "É necessário escolher um identificador para a empresa executora.",
  EXECUTING_ID_ALREADY_EXISTS: "Já existe uma empresa executora salva com esse identificador.",
  SAVE_EXECUTING_COMPANY_SUCCESS: "Empresa executora salva com sucesso!",
  SAVE_EXECUTING_COMPANY_ERROR: "Ocorreu um erro ao salvar as informações da empresa executora.",

  CHOOSE_CLIENT_FIRST: "É necessário escolher um cliente primeiro.",
  CHOOSE_EXECUTING_COMPANY_FIRST: "É necessário escolher uma empresa executora primeiro.",

  ALTER_CLIENT_SUCCESS: "Informações do cliente alteradas com sucesso.",
  ALTER_CLIENT_ERROR: "Ocorreu um erro ao alterar as informações do cliente.",

  ALTER_EXECUTING_COMPANY_SUCCESS: "Informações da empresa executora alteradas com sucesso.",
  ALTER_EXECUTING_COMPANY_ERROR: "Ocorreu um erro ao alterar as informações da empresa executora.",

  REMOVE_CLIENT: "Remover cliente",
  REMOVE_EXECUTING_COMPANY: "Remover empresa executora",

  REMOVE_CLIENT_SUCCESS: "Informações do cliente removidas com sucesso.",
  REMOVE_CLIENT_ERROR: "Ocorreu um erro ao remover as informações do cliente. Verifique se ele ainda está salvo.",

  REMOVE_EXECUTING_COMPANY_SUCCESS: "Informações da empresa executora removidas com sucesso.",
  REMOVE_EXECUTING_COMPANY_ERROR: "Ocorreu um erro ao remover as informações da empresa executora. Verifique se ela ainda está salva.",

  CONFIRM_REMOVE_CLIENT_TEXT: "Tem certeza que deseja remover este cliente?",
  CONFIRM_REMOVE_EXECUTING_COPANY_TEXT: "Tem certeza que deseja remover esta empresa executora?",

  YES: "Sim",
  NO: "Não",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN: "LOGIN",
  ENTER: "Entrar",
  LOGOUT: "Logout",
  RESTART_SYSTEM: "Reiniciar Sistema",
  IP: "IP",
  MASK: "Máscara",
  GATEWAY: "Gateway",
  TAG: "Tag",
  TAGS: "Tags",
  SETUP: "Configurar",
  EDIT: "Editar",
  SOFTWARE_UPDATE: "Atualização de Software",
  INTERFACE_CONFIG: "Configurações de Interface",
  CURRENT_VERSION: "Versão atual: ",
  UPDATE: "Atualizar",
  ALTER_LOGIN: "Alterar login",
  ARE_YOU_SURE_ALTER_CONFIG: "Tem certeza que deseja alterar as configurações do TS Scope H1?",
  INVALID_OR_CORRUPT_FILE: "O arquivo não é válido ou está corrompido.",
  IMPORT: "Importar",
  EXPORT: "Exportar",
  LOGIN_CREDENTIALS_FAILURE: "Ocorreu um erro ao realizar o login: Nome de usuário ou senha incorretos.",
  LOGIN_GENERAL_FALIURE: "Ocorreu um erro ao realizar o login:",

  GPG_ALERT_MESSAGE: "Só é possível enviar arquivos com extensão .gpg",
  GPG_FILE_EXTENSION: ".gpg",
  SEND_FILE_SUCCESS: "O arquivo foi enviado com sucesso.",
  SEND_FILE_SUCCESS_WARNING: "Não esqueça de verificar se a placa de rede do seu computador está na mesma subrede do IP: ",
  SEND_FILE_FAILURE: "Ocorreu um erro ao enviar o arquivo.",
  SEND_FILES_SUCCESS: "Os arquivos foram enviados com sucesso.",
  SEND_FILES_FAILURE: "Ocorreu um erro ao enviar os arquivos.",
  SEND_FILE_WAITING: "Enviando o arquivo.",
  SEND_FILE_WRONG_FILENAME: "Nome inválido. O arquivo de atualização deve chamar-se: updateSH1.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "O arquivo de atualização foi corrompido durante o envio.",
  SEND_CONFIG_SUCCESS: "As configurações foram enviadas com sucesso.",
  SEND_CONFIG_FAILURE: "Ocorreu um erro ao enviar as configurações.",
  SEND_CONFIG_WAITING: "Enviando as configurações.",
  SEND_CONFIG_WAITING_2: "Finalizando envio das configurações.",
  SEND_CONFIG_DONE: "Configurações enviadas.",
  START_MESSAGE_SUCCESS: "O TS Scope H1 irá iniciar em 15 segundos.",
  START_MESSAGE_FAILURE: "Ocorreu um erro ao iniciar o TS Scope H1.",
  STOP_MESSAGE_SUCCESS: "O TS Scope H1 irá parar em 15 segundos.",
  STOP_MESSAGE_FAILURE: "Ocorreu um erro ao parar o TS Scope H1.",
  WAITING: "Aguarde um instante",
  CLEAN_LOG_SUCCESS_1: "O log do 'Canal ",
  CLEAN_LOG_SUCCESS_2: "' foi limpado com sucesso.",
  CLEAN_LOG_FAILURE: "Ocorreu um erro ao limpar o log.",
  CLEAR: "Limpar",
  CLEAN_STATISTICS_SUCCESS: "As estatísticas foram limpadas com sucesso.",
  CLEAN_STATISTICS_FAILURE: "Ocorreu um erro ao limpar as estatísticas.",
  RESET_TRAFFIC_SUCCESS: "Os valores serão zerados na próxima varredura.",
  RESET_TRAFFIC_FAILURE: "Ocorreu um erro ao zerar os incrementos de erro.",
  RESET_DEVICES_SUCCESS: "Os dados de devices foram limpados com sucesso.",
  RESET_DEVICES_FAILURE: "Ocorreu um erro ao limpar os dados de devices.",
  CHANGE_USERNAME_SUCCESS: "O Nome de usuário foi alterado com sucesso. Por favor realize o login novamente.",
  CHANGE_USERNAME_FAILURE: "Ocorreu um erro ao alterar o nome de usuário: ",
  USERNAME_TOO_SHORT: "O nome de usuário precisa conter pelo menos um caractere.",
  PASSWORD_MISSMATCH: "As senhas digitadas não coincidem",
  CHANGE_PASSWORD_SUCCESS: "A senha foi alterada com sucesso. Por favor realize o login novamente.",
  CHANGE_PASSWORD_FAILURE: "Ocorreu um erro ao alterar a senha: ",
  RESET_RETRIES_SUCCESS: "As retentativas foram limpadas com sucesso.",
  RESET_RETRIES_FAILURE: "Ocorreu um erro ao limpar as retentativas.",

  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique as seguintes informações:",
  INVALID_IP: "\n- O IP inserido é inválido",
  INVALID_SUBMASK: "\n- A máscara inserida é inválida",
  INVALID_GATEWAY: "\n- O gateway inserido é inválido",
  INVALID_DNS: "\n- O DNS inserido é inválido",
  LOOPBACK_IP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do TS Scope H1",
  LOOPBACK_IP_NTP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do servidor NTP",
  TAG_TOO_LONG: "O tamanho da tag não pode ultrapassar 30 caracteres",
  SELECT_TIMEZONE: "\n- É necessário selecionar uma Timezone para configurar o servidor NTP",
  SAME_SUBNET_IP_1: "\n- O endereço IP da interface office não pode estar na mesma subrede da interface ETHERNET.",
  SAME_SUBNET_IP_2: "\n- O endereço IP da interface ETHERNET não pode estar na mesma subrede da interface office.",
  SUBNET_OVERLAP_WLAN: "\n- O TS Scope H1 detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a WLAN com o endereço IP e máscara escolhidos.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- O TS Scope H1 detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a interface ETHERNET com o endereço IP e máscara escolhidos.",
  ZERO_IP_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como IP do TS Scope H1",
  ZERO_IP_MASK_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como máscara da rede",
  BROADCAST_IP_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do TS Scope H1",
  NETWORK_IP_MSG: "\n- O IP da rede não pode ser utilizado como IP do TS Scope H1",
  BROADCAST_GATEWAY_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do gateway",
  NETWORK_GATEWAY_MSG: "\n- O IP da rede não pode ser utilizado como IP do gateway",

  CHOOSE_A_CHANNEL: "Para salvar a tag é necessário selecionar um canal",

  ALTER_USERNAME: "ALTERAR USUÁRIO",
  ALTER_PASSWORD: "ALTERAR SENHA",

  SYSTEM: "Sistema",
  RESTART: "Reiniciar",
  CONFIRM_RESTART_SYSTEM: "Tem certeza que deseja reiniciar o sistema?",
  RESTART_SYSTEM_FAILURE: "Ocorreu um erro ao tentar reiniciar o sistema.",
  RESTART_SYSTEM_SUCCESS: "Pedido de reinicialização enviado com sucesso. Aguarde cerca de 3 minutos para que o sistema seja reiniciado completamente.",

  SELECT_FILE: "Por favor selecione um arquivo para ser enviado",
  SELECT_GSD_FLIE: "Por favor selecione ao menos um arquivo GSD para ser enviado",
  SENDING_GSD_FILES: "Enviando arquivos GSD",

  DO_NOT_CLOSE_THIS_TAB: "Deixe esta aba aberta para acompanhar a atualização.",
  UPDATING_MONITOR_FILES: "Atualizando arquivos no TS Scope H1. Por favor aguarde.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Arquivos atualizados, preparando para reiniciar o TS Scope H1.",
  RESTARTING_MONITOR_WAIT: "Reiniciando o TS Scope H1, aguarde alguns minutos.",
  UPDATE_SUCCESS: "A atualização foi realizada com sucesso!",
  UPDATE_ERROR_STRING: "Ocorreu o seguinte erro ao atualizar o TS Scope H1: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique pelo menos um dos campos para atualizar as configurações de interface.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nLembre-se de atualizar o endereço no navegador para: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "As configurações de interface foram atualizadas com sucesso!",

  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Ocorreu um erro ao enviar os seguintes arquivos GSD: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Ocorreu um erro ao remover os seguintes arquivos GSD: ",

  ALTER: "Alterar",
  CHANNELS: "Canais",
  CHANNELS_TAGS: "Tags dos canais",
  DEVICES_TAGS: "Tags dos dispositivos",

  TAG_AND_NOTE_FROM_CHANNEL: "A tag do canal ",
  WAS_SUCCESSFULLY_ALTERED: " foi alterada com sucesso!",
  ALTER_TAG_ERROR: "Ocorreu um erro ao alterar a tag do canal ",
  ALTER_TAG_ERROR_REASON: ".\nMotivo: ",
  ERROR_REASON: ".\nMotivo: ",

  NOTE: "Observação",
  MONITOR_IP: "IP do TS Scope H1",

  IS_IN_SEGMENT_QUESTION: "Pertence ao Segmento?",

  IN_SEGMENT_DEVICES: "Dispositivos do segmento",
  UPDATING_DATA: "Atualizando informações, aguarde",
  IN_SEGMENT_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por endereço",

  IS_IN_SEGMENT_POPUP_DESCRIPTION_1: "Lista de dispositivos pertencentes ao mesmo segmento que este canal do TS Scope H1.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_2: "Se o dispositivo estiver desmarcado nesta lista, isto significa que ele não pertence ao mesmo segmento que este canal do TS Scope H1.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_3: "Se ele não pertencer ao mesmo segmento, a forma de onda vista no osciloscópio pode não corresponder à forma de onda real do dispositivo.",

  CONFIRM_ALTER_SEGMENT_DEVICES: "Tem certeza que deseja realizar as alterações à lista de dispositivos pertencentes ao segmento?",

  ALTER_IS_IN_SEGMENT_LIST_FAILURE: "Ocorreu um erro ao alterar a lista de dispositivos do segmento.",
  ALTER_IS_IN_SEGMENT_LIST_SUCCESS: "A lista de dispositivos do segmento foi alterada com sucesso!",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuração da interface Ethernet.",
  ETHERNET_POPUP_2: "Utilizado para supervisão e acesso Web aos dados do TS Scope H1.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuração da interface sem fio, quando adaptador disponível.",
  WLAN_POPUP_2: "Utilizado para supervisão e acesso Web aos dados do TS Scope H1.",

  SEND_NTP_CONFIG_WAITING: "Enviando as configurações do servidor NTP.",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Ligar servidor NTP",
  TURN_NTP_SERVER_OFF: "Desligar servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "Tem certeza que deseja ligar o servidor NTP? Para isso o TS Scope H1 precisará ser reiniciado.",
  TURN_NTP_SERVER_OFF_QUESTION: "Tem certeza que deseja desligar o servidor NTP? Para isso o TS Scope H1 precisará ser reiniciado.",

  PROCESSING_NTP_INIT: "Iniciando processamento das informações do servidor NTP.",
  PROCESSING_NTP_INFO: "Processando as informações do servidor NTP.",
  PROCESSED_NTP_INFO: "Informações do servidor NTP processadas.",
  PROCESSING_NTP_ERROR: "Ocorreu um erro ao enviar as informações para o servidor NTP. Verifique se o endereço IP do servidor está correto. Caso estiver, verifique também se o serviço de NTP está ligado e tente novamente.",

  NTP_INFO_TURNED_ON_SUCCESS: "O servidor NTP foi ligado com sucesso.",
  NTP_INFO_TURNED_ON_FAILURE: "Ocorreu um erro ao ligar o servidor NTP.",
  NTP_INFO_FAILURE: "Falha ao sincronizar com o servidor. Caso o erro persista entre em contato com o administrador do servidor NTP.",
  TURN_ON_DATE: "\nO horário do servidor foi atualizado para: ",

  MONITOR_WILL_BE_RESTARTED: "\nO TS Scope H1 será reiniciado agora,",
  MONITOR_RESTART_SUCCESS: "O TS Scope H1 foi reiniciado com sucesso.",
  MONITOR_RESTART_FAILURE: "Ocorreu um erro ao reiniciar o TS Scope H1.",

  NTP_INFO_TURNED_OFF_SUCCESS: "O servidor NTP foi desligado com sucesso.",
  NTP_INFO_TURNED_OFF_FAILURE: "Ocorreu um erro ao desligar o servidor NTP.",
  TURN_OFF_DATE: "\nHorário de desligamento: ",

  TAG_CONFIG: "Tag do segmento",

  TAG_WAS_CHANGED_SUCCESSFULLY: "A tag do TS Scope H1 foi modificada com sucesso.",
  TAG_CHANGE_FAILURE: "Ocorreu um erro ao modificar a tag do TS Scope H1.",

  TS_EXPERT_CONFIG_POPUP: "Permite habilitar / desabilitar as não conformidades a serem informadas pela ferramenta.",
  DNS: "DNS",

  // ---------------------------- Edit Tags page related ----------------------------
  ADD_ALTER_TAGS: "Adicionar/Alterar Tags",
  CHOOSE_DEVICE: "Escolha um dispositivo",
  NEW_TAG: "Nova TAG",
  REMOVE_ALL_TAGS: "Remover todas as Tags",
  CONFIRM_REMOVE_ALL_TAGS: "Tem certeza que deseja remover as tags de todos os dispositivos?",
  CHANGE_TAG_SUCCESS: "A tag foi alterada com sucesso.",
  CHANGE_TAG_FAILURE: "Ocorreu um erro ao alterar a tag",
  REMOVE_TAG_SUCCESS: "As tags foram removidas com sucesso.",
  REMOVE_TAG_FAILURE: "Ocorreu um erro ao remover as tags",
  IMPORT_TAGS_SUCCESS: "As tags foram importadas com sucesso",
  IMPORT_TAGS_SUCCESS_1: "As tags do canal ",
  IMPORT_TAGS_SUCCESS_2: " foram importadas com sucesso",

  IMPORT_TAGS_FAILURE: "Ocorreu um erro ao importar as tags: ",
  PLEASE_SELECT_TAG_FILE: "Por favor selecione um arquivo de tags.",
  IMPORT_TAGS: "Importar tags",
  EXPORT_TAGS: "Exportar tags",

  CHOOSE_A_CHANNEL_FIRST: "É necessário selecionar um canal primeiro",
  CHOOSE_A_DEVICE_FIRST: "É necessário selecionar um dispositivo primeiro",

  THE_IP_DP: "O IP: ",
  TOOK_TOO_LONG_TO_RESPOND: " demorou demais para responder.",

  TAGS_CONFIG: "CONFIGURAÇÃO DE TAGS",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configurações WLAN",
  CONNECTION_STATUS: "Estado da conexão",

  WLAN_ADAPTER_ON: "Ligado",
  WLAN_ADAPTER_OFF: "Desligado",

  IP_PLACEHODLER: "192.168.2.210",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Força do sinal",
  FREQUENCY: "Frequência",
  QUALITY: "Qualidade",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Qualidade",

  TURNING_WLAN_OFF_WAITING: "Desligando o adaptador WLAN, por favor aguarde.",
  TURNING_WLAN_ON_WAITING: "Ligando o adaptador WLAN, por favor aguarde.",

  NETWORK: "Rede",
  NETWORK_NAME_1: "Nome da rede",
  SUBMASK: "Máscara",
  PASSWORD: "Senha",

  ALTER_SCOPE_WLAN_CONFIG: "Tem certeza que deseja alterar as configurações de WLAN do TS Scope H1?",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica o estado do adaptador WLAN do TS Scope H1.",
  WLAN_STATUS_POPUP_2: "Caso ele esteja desligado não é possível alterar as configurações WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica se o TS Scope H1 está conectado ou não à rede WLAN configurada.",

  WLAN_CONFIG_POPUP_1: "Não é possível alterar as configurações enquanto o adaptador WLAN estiver desligado.",
  WLAN_CONFIG_POPUP_2: "É altamente recomendado que as configurações de WLAN sejam alteradas apenas ao acessar o TS Scope H1 por meio da rede cabeada.",
  WLAN_CONFIG_POPUP_3: "Ao alterar o IP / máscara, caso os campos apareçam em branco após a atualização isso é um forte indicativo de que:",
  WLAN_CONFIG_POPUP_4: "Já existe um outro dispositivo na rede com o mesmo IP;",
  WLAN_CONFIG_POPUP_5: "A máscara de rede é muito restrita e não comporta o IP que foi passado.",

  WLAN_ADAPTER_NOT_FOUND_1: "O TS Scope H1 não conseguiu encontrar o adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Verifique se o adaptador está desconectado, ou com mau contato;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Caso o adaptador não esteja desconectado nem com mau contato, tente substituí-lo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Se nenhuma das opções anteriores solucionar o problema entre em contato com a Toledo e Souza.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique pelo menos um dos campos para atualizar as configurações WLAN.",
  UPDATE_WLAN_CONFIG_SUCCESS: "As configurações de WLAN foram atualizadas com sucesso!",
  SEND_WLAN_CONFIG_WAITING: "Enviando as configurações, por favor aguarde. Isso pode levar cerca de um minuto.",
  LOADING_WAITING: "Carregando informações, por favor aguarde.",
  WLAN_INFO: "Informações WLAN",
  MAC: "MAC",

  UPDATE_WLAN_CONFIG_ERROR: "Não foi possível conectar à rede WLAN. Caso o problema persista tente reiniciar o TS Scope H1 ou o roteador WLAN.",

  HOSTNAME_POPUP_1: "Um hostname deve possuir entre 2 e 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Além disso, ele pode conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",
  
  INVALID_HOSTNAME_1: "O hostname deve possuir entre 2 e 64 caracteres.",
  INVALID_HOSTNAME_2: "O hostname deve conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",

  HOSTNAME_CONFIG_SUCCESS: "O hostname foi configurado com sucesso.",
  HOSTNAME_CONFIG_ERROR: "Ocorreu um erro ao configurar o hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID Oculto",
  OPTIONAL: " (Opcional)",

  ALTER_MONITOR_WLAN_CONFIG: "Tem certeza que deseja alterar as configurações de WLAN do TS Scope H1?",

  REASON_H1: "Motivo: ",

  // ---------------------------- TS EXPERT CONFIG ---------------------------- 
  SENDING_TS_EXPERT_CONFIG_WAITING: "Atualizando as configurações do TS Expert, aguarde um instante.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "As configurações do TS Expert foram salvas com sucesso.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocorreu um erro ao salvar as configurações do TS Expert.",

  TS_EXPERT_CONFIGURATION: "Configurações do TS Expert",

  H1_TERMINATOR_OFF_LIST_HEADER: "Falta de terminador",
  H1_TERMINATOR_OFF_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de falta de terminação na rede.",

  H1_CAPACITIVE_EFFECT_LIST_HEADER: "Jitter fora de especificação",
  H1_CAPACITIVE_EFFECT_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de jitter fora de especificação.",

  H1_HIGH_RESISTANCE_LIST_HEADER: "Sinal atenuado",
  H1_HIGH_RESISTANCE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de sinal atenuado no meio físico H1.",

  H1_INVERTED_POLARITY_LIST_HEADER: "Polaridade invertida",
  H1_INVERTED_POLARITY_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de polaridade invertida.",

  H1_NOISE_LIST_HEADER: "Ruído",
  H1_NOISE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de ruído na rede.",

  H1_UNBALANCE_LIST_HEADER: "Desbalanceamento",
  H1_UNBALANCE_LIST_CONTENT: "Quando ativada esta opção, o TS Expert indicará ao usuário possível condição de desbalanceamento.",

  H1_GENERAL_SIGNAL_LOSS_HEADER: "Perda geral de sinal",

  // ---------------------------- TS EXPERT ----------------------------
  SCOPE_TAG: "Tag do Scope:",
  CHANNEL_TAG_2: "Tag do canal:",
  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de ações - TS Expert - TS Scope H1",

  TS_EXPERT_POPUP_1: "Nesta aba são apresentadas as informações do TS Expert.",
  TS_EXPERT_POPUP_2: "Esta ferramenta é um sistema especialista desenvolvido para otimizar e acelerar a análise das principais divergências detectadas pelo TS Scope H1 em meio físico H1.",
  TS_EXPERT_POPUP_3: "De forma automatizada, a manutenção, engenharia e equipes relacionadas podem obter uma lista de ações com diferentes eventos, suas possíveis causas, sugestões de solução e os dispositivos nos quais foram detectados.",
  TS_EXPERT_POPUP_4: "O uso do TS Expert não exclui a necessidade da análise humana e tampouco substitui tais capacidades de criar correlações de dados e interpretação.",

  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detectado em: ",
  CHECK_YOUR_NETWORK: "Por favor verifique sua rede.",

  EXPORT_ACTIONS_LIST: "Exportar lista de ações",
  GENERATING_ACTIONS_LIST_WAITING: "Gerando PDF de lista de ações, por favor aguarde.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF gerado com sucesso. Para salvá-lo, clique em salvar lista de ações.",

  EVENTS_LIST: "Lista de eventos",
  ACTIONS: "Ações",

  NO_PROBLEM_DETECTED: "O TS Expert não detectou nenhum evento na rede.",
  NO_EVENTS_TO_BE_ANALYZED: "Não existem eventos a serem analisados.",

  NO_EVENT_SELECTED: "Nenhum evento selecionado",
  CHOOSE_AN_EVENT: "Escolha um evento para visualizar as ações sugeridas.",

  DETAILING: "Detalhamento",

  CHECKED: "Limpar",
  BATCH_CHECK: "Limpar todos",

  PROBLEM_CHECKED: "O evento foi limpo com sucesso",
  PROBLEM_CHECK_ERROR: "Ocorreu um erro ao limpar o evento.",

  QUANTITY_DP: "Quantidade: ",
  INCREMENTS: "Incrementos",

  PORT_IS_STILL_INACTIVE: "A porta ainda está inativa",
  MARK_PROBLEM_AS_SOLVED: "Tem certeza que deseja marcar o evento como limpo?",

  LAST_UPDATED: "Atualizado pela última vez em: ",
  THIS_COMPUTER_TIME: " (Horário deste computador)",

  DEVICE: "Dispositivo",
  DEVICES: "Dispositivos",
  UNKNOWN: "Desconhecido",

  ALL_EVENTS_WERE_CHECKED: "Todos os eventos foram conferidos com sucesso.",
  CHECK_EVENT_OBS: "\nImportante salientar que alguns dados levam até 15 minutos para serem atualizados, desta forma, sugere-se aguardar algum tempo para limpar esta lista clicando em conferir.\n",

  UNABLE_TO_CHECK_TERMINATION_OFF_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o TS Scope H1 continua detectando uma condição de falta de terminação:\n",
  UNABLE_TO_CHECK_CAPACITIVE_EFFECT_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o TS Scope H1 continua detectando Jitter fora de especificação:\n",
  UNABLE_TO_CHECK_NOISE_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o TS Scope H1 continua detectado uma condição de ruído (amplitude maior que 30% da amplitude do sinal do devices):\n",
  UNABLE_TO_CHECK_INVERTED_POLARITY_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o TS Scope H1 continua detectando uma condição de inversão de polaridade:\n",
  UNABLE_TO_CHECK_HIGH_RESISTANCE_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o TS Scope H1 continua detectando sinal atenuado:\n",
  UNABLE_TO_CHECK_UNBALANCE_EVENTS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois o TS Scope H1 continua detectando um desbalanceamento:\n",

  // ---------------------------- H1 TERMINADOR OFF ----------------------------
  H1_TERMINATION_OFF_SUGGESTION_1: "Quando houver falta de terminador sugere-se:",
  H1_TERMINATION_OFF_SUGGESTION_2: "Verificar visualmente se os terminadores em ambas as extremidades do segmento estão ligados, seja no acoplador e na última junction box ou no acoplador e no devices mais distante.",
  H1_TERMINATION_OFF_SUGGESTION_3: "Indica-se aguardar uma parada ou programar com a produção antes de ligar/instalar o terminador.",

  // ---------------------------- EFEITO CAPACITIVO ----------------------------
  CAPACITIVE_EFFECT_SUGGESTION_1: "Quando for detectada presença de Jitter fora de especificação sugere-se:",
  CAPACITIVE_EFFECT_SUGGESTION_2: "Verificar os seguintes itens:",
  CAPACITIVE_EFFECT_SUGGESTION_3: "Isolamento dos equipamentos;",
  CAPACITIVE_EFFECT_SUGGESTION_4: "Umidade no barramento;",
  CAPACITIVE_EFFECT_SUGGESTION_5: "Problemas na eletrônica dos devices;",
  CAPACITIVE_EFFECT_SUGGESTION_6: "Oxidações nas conexões dos devices;",
  CAPACITIVE_EFFECT_SUGGESTION_7: "Oxidações nas conexões das junction box / barreiras;",
  CAPACITIVE_EFFECT_SUGGESTION_8: "Cabo longo.",

  // ---------------------------- HIGH RESISTANCE ----------------------------
  H1_HIGH_RESISTANCE_SUGGESTION_1: "Quando houver sinal atenuado no barramento sugere-se:",
  H1_HIGH_RESISTANCE_SUGGESTION_2: "Verificar se algum equipamento do segmento está com terminador interno ligado, como o caso das junction box. Caso não tenha equipamento algum com terminador interno ligado verificar a eletrônica dos devices, isolando individualmente do barramento.",
  H1_HIGH_RESISTANCE_SUGGESTION_3: "Ainda deve-se verificar pontos de alta resistência como bornes frouxos e cabos amassados.",

  // ---------------------------- INVERTED POLARITY ----------------------------
  H1_INVERTED_POLARITY_SUGGESTION_1: "Quando for detectada presença de polaridade invertida sugere-se:",
  H1_INVERTED_POLARITY_SUGGESTION_2: "Nem todos os acopladores aceitam a polaridade invertida, portanto isso pode gerar problemas na rede.",
  H1_INVERTED_POLARITY_SUGGESTION_3: "Deve-se verificar a instalação, caso esteja correta procurar o fabricante do devices.",

  // ---------------------------- NOISE ----------------------------
  H1_NOISE_SUGGESTION_1: "Quando houver ruído ou baixa isolação (fuga para terra) sugere-se:",
  H1_NOISE_SUGGESTION_2: "Este é um dos problemas mais complexos das redes industriais. Abaixo temos 4 dicas básicas que devem ajudar a solucionar este problema:",
  H1_NOISE_SUGGESTION_3: "Verificar o isolamento das interfaces dos devices, um modo simples é desconectando um a um da rede e verificando se o problema persiste;",
  H1_NOISE_SUGGESTION_4: "Para atenuar o ruído é necessário verificar se todos os devices da rede estão devidamente aterrados;",
  H1_NOISE_SUGGESTION_5: "É necessário verificar a equipotencialização do sistema de terra, um modo simples é verificar se há corrente de fuga nos cabos. Espera-se um valor abaixo de 100mA;",
  H1_NOISE_SUGGESTION_6: "Caso tenha uma corrente maior que 100mA uma dica é isolar a malha no devices, sempre mantendo o devices aterrado.",
  H1_NOISE_SUGGESTION_7: "Se o problema persistir após estas dicas básicas, indicamos procurar um especialista em meio físico H1.",

  // ------------------------ UNBALANCE ---------------------------
  H1_UNBALANCE_SUGGESTION_1: "Quando houver desbalanceamento sugere-se:",
  H1_UNBALANCE_SUGGESTION_2: "Verificar a influência dos dispositivos no barramento pois defeitos que causem alteração nas características elétricas originais dos circuitos eletrônicos e problemas de isolamento eletrônico podem refletir em desbalanceamento do sinal. Outra causa para este problema pode ser a fuga para o aterramento causado por um cabo danificado.",

  // ---------------------------- EXPERT REPORT ----------------------------
  TS_EXPERT_DP: "TS Expert:",
  ACTIONS_LIST: "Lista de ações",

  MONITORING_INIT: "- Início do monitoramento: ",
  REPORT_GENERATION: "- Horário de geração do relatório:",
  CHANNEL_TAG: "- Tag do canal: ",

  H1_TERMINATION_OFF_PAGE_TITLE: ". - Falta de terminador",
  H1_CAPACITIVE_EFFECT_PAGE_TITLE: ". - Jitter fora de especificação",
  H1_HIGH_RESISTANCE_PAGE_TITLE: ". - Sinal Atenuado",
  H1_INVERTED_POLARITY_PAGE_TITLE: ". - Polaridade invertida",
  H1_NOISE_PAGE_TITLE: ". - Ruído ou baixa isolação (fuga para terra)",
  H1_UNBALANCE_PAGE_TITLE: ". - Desbalanceamento",

  SUGGESTION: "Sugere-se",
  EVIDENCE: "Evidências",
  EVIDENCE_SINGULAR: "Evidência",
  EVIDENCE_DESCRIPTION: "Captura de evidência da não conformidade informada pelo TS Expert:",
  NO_EVIDENCE_DESCRIPTION_1: "Em casos de ausência de sinal, a captura de evidência da não conformidade não é mostrada, uma vez que não há sinal a ser analisado.",
  NO_EVIDENCE_DESCRIPTION_2: "Em razão disto, abaixo é apresentada uma tabela contendo todos os dispositivos cujos sinais não foram detectados, seus respectívos canais e o horário em que o problema foi detectado.",

  H1_TERMINATION_OFF_PAGE_DESCRIPTION: "O TS Expert está indicando uma possível falta de terminador na rede.",
  H1_CAPACITIVE_EFFECT_PAGE_DESCRIPTION: "O TS Expert está indicando Jitter fora de especificação.",
  H1_HIGH_RESISTANCE_PAGE_DESCRIPTION: "O TS Expert está indicando possível sinal atenuado.",
  H1_INVERTED_POLARITY_PAGE_DESCRIPTION: "O TS Expert está indicando possível condição de polaridade invertida.",
  H1_NOISE_PAGE_DESCRIPTION: "O TS Expert está indicando possível condição de ruído na rede.",
  H1_UNBALANCE_PAGE_DESCRIPTION: "O TS Expert está indicando possível condição de desbalanceamento.",
  // ---------------------------- ACTIVE CHANNELS ----------------------------
  ACTIVE_CHANNELS: "Canais ativos",
  ACTIVE_CHANNELS_POPUP_1: "Permite configurar quais canais do TS Scope H1 estão ativos no momento (Quais canais serão utilizados).",
  ACTIVE_CHANNELS_POPUP_2: "É recomendado desativar todos os canais que não estiverem sendo utilizados no momento.",
  SAVING_ACTIVE_CHANNELS: "Salvando canais ativos, por favor aguarde.",
  SEND_ACTIVE_CHANNELS_SUCCESS: "Os canais ativos foram salvos com sucesso!\nApós apertar OK você será redirecionado para a página inicial do TS Scope H1.",
  SEND_ACTIVE_CHANNELS_ERROR: "Occoreu um erro ao salvar os canais ativos",
  CANT_TURN_ALL_CHANNELS_OFF: "Não é possível desativar todos os canais do TS Scope H1 ao mesmo tempo.\n\nÉ necessário que ao menos um dos canais permaneça ativo.",

  // ---------------------------- H1 NETWORK VERSION ----------------------------
  H1_NETWORK_VERSION: "Versão do meio físico H1",
  H1_NETWORK_VERSION_2: "Versão 2.0",
  H1_NETWORK_VERSION_2_1: "Versão 2.1",
  H1_NETWORK_VERSION_POPUP_1: "Permite configurar a versão do meio físico H1 monitorada por cada um dos canais do TS Scope H1.",
  H1_NETWORK_VERSION_POPUP_2: "Os meios físicos H1 que utilizam o protocolo na versão 2.0 suportam até 32 dispositivos por rede, endereçados de 1 até 32.",
  H1_NETWORK_VERSION_POPUP_3: "Já os meios físicos H1 que utilizam o protocolo na versão 2.1 ou superior suportam até 64 dispositivos, endereçados de 1A até 32A e de 1B até 32B.",
  DISABLED_CHANNELS_POPUP_1: "Alguns canais podem aparecer como desabilitados nesta tela, e a versão do meio físico H1 não poderá ser modificada.",
  DISABLED_CHANNELS_POPUP_2: "Isso ocorre quando eles estiverem desligados, para modificar a versão de rede do canal, vá até a tela de configrações dos canais e habilite-os.",
  SEND_H1_TYPE_SUCCESS_1: "A versão da rede do 'Canal ",
  SEND_H1_TYPE_SUCCESS_2: "' foi salva com sucesso!",
  SEND_H1_TYPE_ERROR: "Occoreu um erro ao salvar a versão da rede do 'Canal ",

  H1_TERMINATION_OFF_DOTS: ".....................................................................................................................",
  H1_CAPACITIVE_EFFECT_DOTS: "........................................................................................................",
  H1_HIGH_RESISTANCE_DOTS: ".............................................................................................................................",
  H1_INVERTED_POLARITY_DOTS: "....................................................................................................................",
  H1_NOISE_DOTS: "............................................................................................................................................",
  H1_UNBALANCE_DOTS: ".....................................................................................................................",
  H1_DISCLAIMER_EXPERT_DOTS: "....................................................................................................................................",

  // ---------------------------- LOADING ----------------------------
  INITIALIZING_SCOPE_DP: "Inicializando TS Scope H1, por favor aguarde."

});